export default __webpack_public_path__ + "static/media/Group 35.c3ad4c6c.svg";